import { render, staticRenderFns } from "./LegalDocument.vue?vue&type=template&id=7bf8701a&scoped=true"
import script from "./LegalDocument.vue?vue&type=script&lang=js"
export * from "./LegalDocument.vue?vue&type=script&lang=js"
import style0 from "./LegalDocument.vue?vue&type=style&index=0&id=7bf8701a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf8701a",
  null
  
)

export default component.exports